import {initFunctionalityAnimation} from './functionality-animation';

const MOBILE_MEDIA = '(max-width: 767px)';

const sliderWrapper = document.querySelector('.functionality__slider-content');
let sliderIndexCurrent;
let sliderOverallCount;

const sliderOptions = {
  slidesPerView: 'auto',
  rtl: true,
  navigation: {
    nextEl: '.functionality__slider-btn--next',
    prevEl: '.functionality__slider-btn--prev',
    disabledClass: 'functionality__slider-btn--hidden',
  },
};

let slider = null;
let isSliderActive = false;

const destroySlider = () => {
  if (!isSliderActive) {
    return;
  }

  slider.destroy();
  slider = null;
  isSliderActive = false;
};

const initSlider = () => {
  const sliderElement = sliderWrapper.querySelector('.functionality__slider');

  if (!sliderElement) {
    return;
  }

  // eslint-disable-next-line no-undef
  slider = new Swiper(sliderElement, sliderOptions);
  isSliderActive = true;

  if (sliderIndexCurrent && sliderOverallCount) {
    sliderIndexCurrent.textContent = slider.activeIndex + 1;
    sliderOverallCount.textContent = slider.slides.length;

    slider.on('slideChange', function () {
      sliderIndexCurrent.textContent = slider.activeIndex + 1;
    });
  }
};

const checkMedia = () => {
  if (window.matchMedia(MOBILE_MEDIA).matches) {
    if (!isSliderActive) {
      initSlider();
    }
  } else {
    if (isSliderActive) {
      destroySlider();
    }
  }
};

const initFucntionalitySlider = () => {
  if (!sliderWrapper) {
    return;
  }

  sliderIndexCurrent = sliderWrapper.querySelector('.index-current-js');
  sliderOverallCount = sliderWrapper.querySelector('.index-overall-js');

  checkMedia();
  initFunctionalityAnimation(sliderWrapper);
  window.addEventListener('resize', checkMedia);
};

export {initFucntionalitySlider};
